import { errorTypes } from '../constants';
import { writeConsoleLog, getApiUri, getCorsPolicy } from './toolkit';
import { UnauthorizedProcess } from '../messages/systemMessages';

export async function getRequest(dispatch, url, requestType, responseType, errorType) {
    writeConsoleLog(requestType);
    url = getApiUri(url);
    writeConsoleLog('GET Url: ' + url);

    dispatch({ type: requestType });
    await fetch(url, {
        credentials: getCorsPolicy(),
        method: 'GET',
        headers: {
        }
    })
        .then(response => {
            if (response.status === 401 || response.status === 403) {
                return { status: response.status };
            }
            else
                return response.json().then(json => ({ status: response.status, json }));
        })
        .then(
            // Both fetching and parsing succeeded!
            ({ status, json }) => {
                if (status === 401 || status === 403) {
                    // Unauthorized
                    writeConsoleLog(errorType);
                    writeConsoleLog('Status ' + status);
                    dispatch({ type: errorType, httpStatus: status, data: { errorType: errorTypes.Unauthorized, message: UnauthorizedProcess } });
                }
                else if (status >= 400) {
                    // Status looks bad
                    writeConsoleLog(errorType);
                    writeConsoleLog('Status ' + status + ' and Json;');
                    writeConsoleLog(json);
                    dispatch({ type: errorType, httpStatus: status, data: json });

                } else {
                    // Status looks good
                    writeConsoleLog(responseType);
                    writeConsoleLog('Status ' + status + ' and Json;');
                    writeConsoleLog(json);
                    dispatch({ type: responseType, httpStatus: status, data: json });
                }
            },
            // Either fetching or parsing failed!
            err => {
                writeConsoleLog(errorType);
                writeConsoleLog('Error Message;');
                writeConsoleLog(String(err));
                dispatch({ type: errorType, data: { errorType: errorTypes.Fatal, message: String(err) } });
            }
        );
}

export async function createRequest(dispatch, url, data, requestType, responseType, errorType, getResponse = false) {
    await postRequest(dispatch, url, data, requestType, responseType, errorType, getResponse);
}

export async function postRequest(dispatch, url, data, requestType, responseType, errorType, getResponse = false) {
    writeConsoleLog(requestType);
    url = getApiUri(url);
    writeConsoleLog('POST Url: ' + url);
    writeConsoleLog('Body;');
    writeConsoleLog(JSON.stringify(data));

    dispatch({ type: requestType });
    await fetch(url,
        {
            credentials: getCorsPolicy(),
            method: 'POST', body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 200 && getResponse) {
                return response.json().then(json => ({ status: response.status, json }));
            }
            else if (response.status === 200 || response.status === 401 || response.status === 403) {
                return { status: response.status };
            }
            else
                return response.json().then(json => ({ status: response.status, json }));
        })
        .then(
            // Both fetching and parsing succeeded!
            ({ status, json }) => {
                if (status === 401 || status === 403) {
                    // Unauthorized
                    writeConsoleLog(errorType);
                    writeConsoleLog('Status ' + status);

                    dispatch({ type: errorType, httpStatus: status, data: { errorType: errorTypes.Unauthorized, message: UnauthorizedProcess } });
                }
                else if (status >= 400) {
                    // Status looks bad
                    writeConsoleLog(errorType);
                    writeConsoleLog('Status ' + status + ' and Json;');
                    writeConsoleLog(json);
                    dispatch({ type: errorType, httpStatus: status, data: json });
                } else {
                    // Status looks good
                    writeConsoleLog('Status ' + status + ' and Json;');
                    writeConsoleLog(json);
                    dispatch({ type: responseType, httpStatus: status, data: json });
                }
            },
            // Either fetching or parsing failed!
            err => {
                writeConsoleLog(errorType);
                writeConsoleLog('Error Message;');
                writeConsoleLog(String(err));
                dispatch({ type: errorType, data: { errorType: errorTypes.Fatal, message: String(err) } });
            }
        );
}

export async function updateRequest(dispatch, url, data, requestType, responseType, errorType, getResponse = false) {
    writeConsoleLog(requestType);
    url = getApiUri(url);
    writeConsoleLog('PUT Url: ' + url);
    writeConsoleLog('Body;');
    if (data !== null)
        writeConsoleLog(JSON.stringify(data));

    dispatch({ type: requestType });
    await fetch(url,
        {
            credentials: getCorsPolicy(),
            method: 'PUT',
            body: data === null ? null : JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 200 && getResponse)
                return response.json().then(json => ({ status: response.status, json }));
            else if (response.status === 200 || response.status === 401 || response.status === 403) {
                return { status: response.status };
            }
            else
                return response.json().then(json => ({ status: response.status, json }));
        })
        .then(
            // Both fetching and parsing succeeded!
            ({ status, json }) => {
                if (status === 401 || status === 403) {
                    // Unauthorized
                    writeConsoleLog(errorType);
                    writeConsoleLog('Status ' + status);
                    dispatch({ type: errorType, httpStatus: status, data: { errorType: errorTypes.Unauthorized, message: UnauthorizedProcess } });
                }
                else if (status >= 400) {
                    // Status looks bad
                    writeConsoleLog(errorType);
                    writeConsoleLog('Status ' + status + ' and Json;');
                    writeConsoleLog(json);
                    dispatch({ type: errorType, httpStatus: status, data: json });
                } else {
                    // Status looks good
                    writeConsoleLog('Status ' + status + ' and Json;');
                    writeConsoleLog(json);
                    dispatch({ type: responseType, httpStatus: status, data: json });
                }
            },
            // Either fetching or parsing failed!
            err => {
                writeConsoleLog(errorType);
                writeConsoleLog('Error Message;');
                writeConsoleLog(String(err));
                dispatch({ type: errorType, data: { errorType: errorTypes.Fatal, message: String(err) } });
            }
        );
}

export async function deleteRequest(dispatch, url, requestType, responseType, errorType) {
    writeConsoleLog(requestType);
    url = getApiUri(url);
    writeConsoleLog('DELETE Url: ' + url);

    dispatch({ type: requestType });
    await fetch(url, { credentials: getCorsPolicy(), method: 'DELETE' })
        .then(response => {
            if (response.status === 200 || response.status === 401 || response.status === 403) {
                return { status: response.status };
            }
            else
                return response.json().then(json => ({ status: response.status, json }));
        })
        .then(
            // Both fetching and parsing succeeded!
            ({ status, json }) => {
                if (status === 401 || status === 403) {
                    // Unauthorized
                    writeConsoleLog(errorType);
                    writeConsoleLog('Status ' + status);
                    dispatch({ type: errorType, httpStatus: status, data: { errorType: errorTypes.Unauthorized, message: UnauthorizedProcess } });
                }
                else if (status >= 400) {
                    // Status looks bad
                    writeConsoleLog(errorType);
                    writeConsoleLog('Status ' + status + ' and Json;');
                    writeConsoleLog(json);
                    dispatch({ type: errorType, httpStatus: status, data: json });
                } else {
                    // Status looks good
                    dispatch({ type: responseType, httpStatus: status });
                }
            },
            // Either fetching or parsing failed!
            err => {
                writeConsoleLog(errorType);
                writeConsoleLog('Error Message;');
                writeConsoleLog(String(err));
                dispatch({ type: errorType, data: { errorType: errorTypes.Fatal, message: String(err) } });
            }
        );
}



// WEBPACK FOOTER //
// ./src/tools/apiMiddleware.js